import { Input, Select } from "antd";
import { constants } from "../../../constant/constants";
import { getParsedNumber } from "../../../utils/Common";

function FoodDiscount({ records }) {
  const { discount, isDiscountInPercent, setDisCount, setIsDiscountInPercent } = records;

  const discountTypeList = [
    {
      value: "1",
      label: constants.DISCOUNT_TYPE.AMOUNT,
    },
    {
      value: "2",
      label: constants.DISCOUNT_TYPE.PERCENTAGE,
    },
  ];

  const handleOnChangeDiscount = (e) => {
    const val = e.target.value;

    if (/^\d{0,6}(\.\d{0,2})?$/.test(val)) {
      if (val === "") {
        setDisCount("");
        return;
      }

      if (!isDiscountInPercent) {
        setDisCount(val);
      }

      if (isDiscountInPercent && parseFloat(val) <= 100) {
        setDisCount(val);
      }
    }
  };

  const onChangeDiscountType = (value) => {
    const findDiscountTypeById = discountTypeList.find((it) => it.value === value);

    const isDiscountInPercentage = findDiscountTypeById.label === constants.DISCOUNT_TYPE.PERCENTAGE;

    setIsDiscountInPercent(isDiscountInPercentage);

    if (isDiscountInPercentage && getParsedNumber(discount) > 100) {
        setDisCount('');
    }
  };

  return (
    <div className="w-full flex flex-row flex-nowrap gap-x-[30px] mb-[20px]">
      <div className="w-1/2 flex flex-col">
        <div className="text-sm font-semibold flex flex-row">
          <div>Discount</div>
        </div>

        <div className="flex flex-row flex-nowrap items-center">
          <Input placeholder="Discount amount" value={discount} onChange={handleOnChangeDiscount} />

          <div className="content-center ml-1">{isDiscountInPercent === true ? "%" : "TK"}</div>
        </div>
      </div>

      <div className="w-1/2">
        <div className="text-sm font-semibold flex flex-row">
          <div>Discount Type</div>
        </div>
        <Select
          value={isDiscountInPercent ? constants.DISCOUNT_TYPE.PERCENTAGE : constants.DISCOUNT_TYPE.AMOUNT}
          className="w-[100%]"
          onChange={onChangeDiscountType}
          options={discountTypeList}
          defaultValue={discountTypeList[0]}
        />
      </div>
    </div>
  );
}

export default FoodDiscount;
